/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "cashoauth": {
            "nested": {
              "apiProto": {
                "nested": {
                  "Scope": {
                    "values": {
                      "API_KEYS_READ": 1,
                      "API_KEYS_WRITE": 2,
                      "BRANDS_READ": 3,
                      "BRANDS_WRITE": 4,
                      "CUSTOMERS_READ": 5,
                      "DISPUTES_READ": 6,
                      "DISPUTES_WRITE": 7,
                      "GRANTS_READ": 8,
                      "GRANTS_WRITE": 9,
                      "MERCHANTS_READ": 10,
                      "MERCHANTS_WRITE": 11,
                      "PAYMENTS_READ": 12,
                      "PAYMENTS_WRITE": 13,
                      "REFUNDS_READ": 14,
                      "REFUNDS_WRITE": 15,
                      "WEBHOOK_CONFIG_READ": 16,
                      "WEBHOOK_CONFIG_WRITE": 17,
                      "WEBHOOK_EVENTS_READ": 18,
                      "OFFERS_WRITE": 19,
                      "OFFERS_READ": 20,
                      "ORDERS_WRITE": 21,
                      "ORDERS_READ": 22,
                      "MESSAGES_WRITE": 23,
                      "MESSAGES_READ": 24,
                      "FEE_PLANS_READ": 25,
                      "BTC_WITHDRAWALS_WRITE": 26,
                      "BTC_WITHDRAWALS_READ": 27,
                      "DEPOSITS_READ": 28,
                      "DEPOSITS_WRITE": 29,
                      "BANK_ACCOUNTS_READ": 30,
                      "BANK_ACCOUNTS_WRITE": 31,
                      "SETTLEMENT_CONFIGURATIONS_READ": 32,
                      "SETTLEMENT_CONFIGURATIONS_WRITE": 33,
                      "FINPLAT_ISSUING_3DS_WRITE": 34,
                      "FDX_TRANSACTIONS_READ": 35,
                      "FDX_ACCOUNT_BASIC_READ": 36,
                      "FDX_ACCOUNT_DETAILED_READ": 37,
                      "CUSTOMER_PROFILE_READ": 38,
                      "FDX_CUSTOMER_CONTACT_READ": 39,
                      "FDX_CUSTOMER_PERSONAL_READ": 40,
                      "PAYOUTS_READ": 41,
                      "PAYOUTS_WRITE": 42,
                      "OPENID": 43,
                      "FDX_STATEMENTS": 44,
                      "CASH_C_TOKEN": 45
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.cashoauth?.nested?.apiProto?.nested?.Scope) {
  $root.addJSON(jsonData);
}

/**
 * Permission scopes for third-party Cash App operations.
 *
 * SOURCE Scope @ squareup/cash/cashoauth/apiProto/scope.proto at 10:1
 */
export const Scope = $root.lookupEnum('squareup.cash.cashoauth.apiProto.Scope').values;